import { AccordionFeatureSection } from "./components/sections/AccordionFeatureSection";
import { CarouselAnimation } from "./new_home/components/CarouselAnimation";
import { CoverageSection } from "./about/components/CoverageSection";
import { FeatureSection } from "./components/sections/FeatureSection";
import { Footer } from "./footer/NewFooter";
import { Hero } from "./new_home/components/Hero";
import ProviderNavigation from "../ProviderNavigation";
import { StatsSection } from "./components/sections/StatsSection";
import { TestimonialSection } from "./new_home/components/TestimonialSection";
import { accordionFeatureSections } from "./new_home/config/accordionSections";
import { featureSections } from "./new_home/config/featureSections";
import { testimonials } from "./new_home/config/testimonials";

export default function NewHomePage() {
  return (
    <div className="tw-relative tw-min-h-screen tw-overflow-x-hidden">
      <div className="tw-bg-[#1A3188] tw-bg-[url('/landing_page_assets/backgrounds/bg.jpg')] tw-bg-cover tw-bg-right-bottom">
        <ProviderNavigation isDark />
        <div className="tw-relative tw-mx-auto tw-mt-[3em] tw-max-w-[1448px] tw-px-[1.25em]">
          <div className="tw-flex tw-h-full tw-flex-col">
            <div>
              <Hero />
              <CarouselAnimation />
            </div>
            <StatsSection
              className="tw-pb-[4em] min840:tw-grid-cols-4"
              stats={[
                { value: ">95%", description: "orders delivered on time" },
                {
                  value: ">85%",
                  description: "of orders don't need follow-up",
                },
                { value: "15-20", description: "minutes saved per DME order" },
                { value: "81", description: "provider NPS" },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="tw-mx-auto tw-flex tw-h-full tw-max-w-[1448px] tw-flex-col tw-gap-y-[5em] tw-px-[1.5em] min440:tw-gap-y-[7.5em]">
        <AccordionFeatureSection
          title="Who is Verse for?"
          sections={accordionFeatureSections}
          rivSrc=""
          imageSrc="/landing_page_assets/home_page/img2.png"
          className="tw-mt-[4em]"
        />
        <TestimonialSection testimonials={testimonials} />
        {featureSections.map((section, index) => (
          <FeatureSection
            key={`feature-section-${index}`}
            {...section}
            className={`${section.className} min440:tw-px-[61px]`}
          />
        ))}
      </div>
      <div className="tw-mt-[5em] min440:tw-mt-[7.5em]">
        <CoverageSection
          title="Comprehensive service in 49 states and DC"
          descriptions={[
            "Verse delivers across the United States, including to rural and underserved areas, and accepts nearly all insurance plans.",
          ]}
        />
      </div>
      <Footer
        hasGradient
        isRounded
        hasSquiggle
        title="DME."
        titleAccent="Resolved."
        description="See how Verse can benefit your organization."
      />
    </div>
  );
}
